<template lang="html">
<div style="margin-top: 0em;" >
    <v-container style="text-align: center;">
      <div >
        <h1>{{$t('how.TITLE')}}</h1>
        <div class="subh1"> {{$t('how.TEXT')}} </div>
      </div>

      <v-layout align-center
      style="margin-top: 2em; vertical-align: top; margin-left: auto; margin-right: auto; max-width: 300px; height: 80px;" class="hidden-sm-and-down">
      <div class="fb-share-button"
      data-layout="button_count"
      :data-href="requireImgUrl()"
      data-size="small"
      style="margin-top: 0em;vertical-align: top; horizontal-align: left;margin-left: auto; margin-right: auto;">

      <a target="_blank"
      :href="urlFacebook()"
      class="fb-xfbml-parse-ignore">
      <img src="../../public/img/facebook.png" alt="Facebook"
      style="width: auto; height: auto;max-width: 50px;max-height: 50px;vertical-align: top; horizontal-align: left;"
      />
      </a>

      <a
      :href="urlLinkedin()"
      style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
      target="_blank">
      <img src="../../public/img/linkedin.png" alt="LinkedIn"
      style="width: auto; height: auto;max-width: 50px;max-height: 50px;vertical-align: top; horizontal-align: left;"/>
      </a>
      <a
      :href="urlTwitter()"
      style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
      target="_blank">
      <img src="../../public/img/twitter.png" alt="Twitter"
      style="width: auto; height: auto;max-width: 50px;max-height: 50px;vertical-align: top; horizontal-align: left;"/>
      </a>
      <a
      :href="urlMail()"
      style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
      >
      <img src="../../public/img/email.png" alt="Email"
      style="width: auto; height: auto;max-width: 50px;max-height: 50px;vertical-align: top; horizontal-align: left;"/>
      </a>
      </div>

      </v-layout>

    </v-container>

    <v-container>
      <v-layout row wrap>
        <v-flex  v-for="card in cards" md3 >
          <v-container>
          <v-card flat elevation="6" color="grey lighten-2">
              <v-img
                :src="card.image"
                aspect-ratio="1"
              ></v-img>

              <v-card-title primary-title style="padding-left: 10px; padding-right: 10px; text-align: center;">
                <div>
                  <h4 class="headline mb-0">{{card.title}}</h4>
                  <div> {{ card.text }} </div>
                </div>
              </v-card-title>
            </v-card>
          </v-container>
          </v-flex>
      </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
  methods: {
    getLang() {
      return navigator.language.slice(0, 2)
    },
    requireImg(imgName) {
      const lang = this.getLang()
      const img = require('../../public/img/' + lang + '_' + imgName)
      if (img) return img
      else return require('../../public/img/en_' + imgName)
    },
    requireImgUrl (){
      return 'http://www.shayofae.com'
    },
    urlFacebook (){
       return 'https://www.facebook.com/sharer/sharer.php?u='+this.requireImgUrl()+'&src=sdkpreparse'
    },
    urlLinkedin (){
       return 'http://www.linkedin.com/shareArticle?mini=true&url='+this.requireImgUrl()
    },
    urlTwitter (){
       return 'https://twitter.com/intent/tweet?url='+this.requireImgUrl()+'&text=Share%20Your%20Farming%20Experience&hashtags=shayofae'
    },
    urlMail (){
       return 'mailto:?Subject= Share Your Farming experience&Body=I%20saw%20this%20and%20thought%20of%20you!%20 %20'+this.requireImgUrl()
//       '+'<a href="'+this.requireImgUrl()+'">Shayofae</a>'
    }
  },
  data() {
    return {
      cards: [{
        image: this.requireImg('Ecran 1.png'),
        title: this.$t('card.why1.TITLE'),
        text: this.$t('card.why1.TEXT')
      }, {
        image: this.requireImg('Ecran 3.png'),
        title: this.$t('card.why2.TITLE'),
        text: this.$t('card.why2.TEXT')
      }, {
        image: this.requireImg('Ecran 4.png'),
        title: this.$t('card.why3.TITLE'),
        text: this.$t('card.why3.TEXT')
      }, {
        image: this.requireImg('Ecran 5.png'),
        title: this.$t('card.why4.TITLE'),
        text: this.$t('card.why4.TEXT')
      }]
    }
  }
}
</script>

<style lang="css" scoped>
h1 {
  font-size: 4em;
  padding: 0.2em;
  margin: 0.2em;
}

.subh1{
  font-size: 2.5em;
}
</style>
